export const cacheKey = 'tracker-folders'
export const url = 'trackers/folders?api-version=3.3'
export const baseUrl = 'trackers/folders?api-version=3.3'
